<template>
  <div class="row">
    <div class="col-xs-12">
      <h3>Downloads</h3>
      <ul class="downloads">
        <li>
          <a :href="download('csv')" target="_blank">
            <span class="label label-success">CSV</span>
          </a>
        </li>
        <li>
          <a :href="download('pdf')" target="_blank">
            <span class="label label-danger">PDF</span>
          </a>
        </li>
        <li>
          <a :href="download('json')" :target="'_blank'">
            <span class="label label-warning">JSON</span>
          </a>
        </li>
        <li>
          <a href="#" @click.prevent="openModal">
            <span class="label label-info">Dicionário</span>
          </a>
        </li>
      </ul>
    </div>

    <div v-if="isModalVisible" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h4>Dicionário de Dados</h4>
        </div>
        <div class="modal-body">
          <div v-if="isLoading">
            Carregando...
          </div>

          <table v-if="!isLoading && dictionaryContent.length > 0" class="dictionary-table">
            <thead>
              <tr>
                <th>Campo</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in dictionaryContent" :key="item.campo" :class="item.classe">
                <td>{{ item.campo }}</td>
                <td>{{ getDescricao(item.campo) }}</td>
              </tr>
            </tbody>
          </table>

          <div v-if="!isLoading && error">
            {{ error }}
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="close-button">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalVisible: false,
      isLoading: false,
      dictionaryContent: [],
      error: null,
      descricoes: {
        'codigo': 'Código de identificação principal do dado.',
        'nome': 'Nome completo do dado.',
        'descricao': 'Descrição detalhada sobre o que o dado representa.',
        'fonte': 'Fonte oficial da informação.',
        'tipoValor': 'Tipo de valor que o dado armazena (I - Numérico inteiro; D - Numérico decimal, T - Texto).',
        'periodicidade': 'Agrupador de dados de periodicidade.',
        'periodicidade.codigo': 'Código que representa a periodicidade do dado.',
        'periodicidade.descricao': 'Frequência com que o dado é atualizado (Anual, Mensal, etc).',
        'tags': 'Agrupador de tags (palavras-chave).',
        'tags.codigo': 'Código da tag ou palavra-chave associada.',
        'tags.descricao': 'Nome da tag ou palavra-chave associada.',
        'secretarias': 'Agrupador de dados das secretarias.',
        'secretarias.codigo': 'Código da secretaria responsável.',
        'secretarias.dado_codigo': 'Código interno da relação com a secretaria.',
        'secretarias.sigla': 'Sigla da secretaria responsável.',
        'secretarias.nome': 'Nome completo da secretaria responsável.',
        'autarquias': 'Agrupador de dados das autarquias.',
        'autarquias.codigo': 'Código da autarquia responsável.',
        'autarquias.dado_codigo': 'Código interno da relação com a autarquia.',
        'autarquias.sigla': 'Sigla da autarquia responsável.',
        'autarquias.nome': 'Nome completo da autarquia responsável.',
        'metas': 'Agrupador de dados das Metas ODS.',
        'metas.codigo': 'Código da meta (ODS) relacionada.',
        'metas.numero': 'Número da meta (ODS) relacionada.',
        'metas.titulo': 'Título da meta (ODS) relacionada.',
        'metas.objetivo': 'Objetivo da meta (ODS) relacionada.',
        'metas.imagem_url': 'URL da imagem representativa da meta (ODS).',
        'metas.link': 'Link para mais informações sobre a meta (ODS).',
        'eixos': 'Agrupador de eixos temáticos.',
        'eixos.codigo': 'Código do eixo temático relacionado.',
        'eixos.descricao': 'Descrição do eixo temático relacionado.',
        'valores': 'Agrupador dos valores do indicador.',
        'valores.codigo': 'Código de identificação único do registro de valor.',
        'valores.data': 'Data de referência do valor.',
        'valores.valor': 'O valor numérico ou textual do indicador para o período.',
        'valores.descricao': 'Descrição textual para valores do tipo texto ou observação específica.'
      }
    };
  },
  methods: {
    download(type) {
      var url =
        this.$root.$data.apiUrl +
        'detalhes/downloads/' +
        type +
        '/' +
        this.$route.params.id
      return url
    },
    closeModal() {
      this.isModalVisible = false
    },
    async openModal() {
      this.isModalVisible = true
      this.isLoading = true
      this.dictionaryContent = []
      this.error = null

      try {
        const url = this.download('dicionario')
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Erro ao buscar os dados do dicionário.');
        }
        const data = await response.json();
        this.dictionaryContent = this.processarDicionario(data);
      } catch (err) {
        this.error = err.message;
        console.error("Erro ao buscar o dicionário:", err);
      } finally {
        this.isLoading = false;
      }
    },
    getDescricao(campo) {
      if (this.descricoes[campo]) {
        return this.descricoes[campo];
      }
      
      return 'Descrição não disponível.';
    },
    processarDicionario(campos) {
        const mapa = {};
        const resultadoPlano = [];
        
        campos.forEach(campo => {
            const raiz = campo.split('.')[0];
            if (!mapa[raiz]) {
                mapa[raiz] = {
                    temRaiz: campos.includes(raiz), 
                    subcampos: []
                };
            }
            if (campo !== raiz) {
                mapa[raiz].subcampos.push(campo);
            }
        });
        
        for (const chave in mapa) {
            const grupo = mapa[chave];
            if (grupo.temRaiz) {
                resultadoPlano.push({ campo: chave, classe: 'grupo-principal' });
                grupo.subcampos.forEach(subcampo => {
                    resultadoPlano.push({ campo: subcampo, classe: 'sub-item' });
                });
            } else {
                grupo.subcampos.forEach(subcampo => {
                    resultadoPlano.push({ campo: subcampo, classe: 'sub-item-sem-raiz' });
                });
            }
        }

        return resultadoPlano;
    }
  }
}
</script>

<style scoped>
a>span.label {
  display: inline-block;
  padding: 10px;
  border-radius: 10px / 20px;
  min-width: 50px;
}

.downloads {
  padding-left: 25px;
}

.downloads>li {
  float: left;
  list-style: none;
  margin-right: 5px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 1rem;
  min-width: 60%;
  max-width: 80%;
  max-height: 80vh;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: .25rem solid #dee2e6;
  padding-bottom: 2rem;
  margin-bottom: 1.75rem;
}

.modal-header h4 {
  margin: 0;
  font-size: 2.5rem;
}

.modal-body {
  overflow-y: auto;
  font-size: 1.75rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  border-top: .25rem solid #dee2e6;
  padding-top: 2rem;
  margin-top: 1rem;
}

.close-button {
  border: none;
  background: rgb(196, 52, 52);
  color: white;
  border-radius: 1rem;
  font-weight: bold;
  cursor: pointer;
  padding: 1rem 1.5rem;
  line-height: 1;
  font-size: 1.5rem;
}

.close-button:hover {
  background: rgba(196, 52, 52, 0.8);
}

.dictionary-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.5rem;
}

.dictionary-table th,
.dictionary-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.dictionary-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.dictionary-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.grupo-principal td:first-child {
    font-weight: bold;
}

.sub-item td:first-child {
    padding-left: 40px;
}

.sub-item {
    background-color: #fafafa !important;
}

</style>


// WEBPACK FOOTER //
// src/components/Dados/Downloads.vue